import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { updateDocument } from "../redux/documentsSlice";
import { debounce } from "../utils/debounce";

export const Editor = () => {
  const dispatch = useAppDispatch();
  const activeDocumentId = useAppSelector((state) => state.documents.activeDocumentId);
  const activeDocument = useAppSelector((state) =>
    state.documents.documents.find((d) => d.id === activeDocumentId)
  );
  const [content, setContent] = useState(activeDocument?.content || "");

  useEffect(() => {
    setContent(activeDocument?.content || "");
  }, [activeDocumentId]);

  const debouncedUpdate = debounce((content: string) => {
    if (activeDocumentId) {
      dispatch(updateDocument({ id: activeDocumentId, content }));
    }
  }, 500);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setContent(e.target.value);
    debouncedUpdate(e.target.value);
  };

  if (!activeDocument) 
    return <div className="p-4 flex justify-center text-gray-400 text-sm h-full items-center">
              <span>No Document Selected</span>
            </div>;

  return (
    <textarea
      className="w-full h-full p-4 outline-none"
      value={content}
      onChange={handleChange}
      placeholder="Write your markdown here..."
    />
  );
};